import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-the-painting',
  templateUrl: './about-the-painting.component.html',
  styleUrls: ['./about-the-painting.component.scss']
})
export class AboutThePaintingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
